module.exports = __webpack_public_path__ + "6f23365e4c604b4231b9fdb333385307.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/email_attachement.png
// module id = 1
// module chunks = 0 1 2 3 4